import React from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  getWalletDetails,
  getbetHistoryData,
} from "../../actions/gameSettings";
import { useState, useEffect } from "react";

import Select from "react-select";
import { isEmpty } from "../../lib/isEmpty";
import { formatEventKickoff, formatPlacedAt, momentFormat } from "../../lib/dateFormat";
import DataFetchStatus from "../../common/DataFetchStatus";
import { isDTS } from "../../../utility/platform";
import {
  getEntryTypeLabel,
  getFeaturedMarketLabel,
  getGoldCoinName,
  getSweepsCoinName,
  getTerm,
} from "../../../utility/complianceCopy";
import { loadEntryHistoryFailedMessage } from "../../../utility/entryCopy";
import { formatOdds, formatPoint, formatTotalPoint } from "../../../utility/odds";
import { formatWagerAmount } from "../../../utility/wagerDisplay";
import {
  historyResultStatus,
  historyResultIsNeutralAmount,
} from "./historyResultDisplay";

const figureNumber = (amount) =>
  (Number(amount) || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const entryAmount = (amount, bucket) => {
  const formatted = (Number(amount) || 0).toFixed(2);
  return isDTS() ? formatWagerAmount(formatted, bucket) : `$${formatted}`;
};

const selectionLine = (leg) => {
  const market = leg?.oddType || "";
  if (market === "totals") {
    return `Total ${formatTotalPoint(leg.point, leg.pointType || leg.teamName)}`;
  }
  if (market === "spreads") {
    const book = leg.originalPoint ? formatPoint(leg.originalPoint) : "";
    const line = leg.point ? formatPoint(leg.point) : "";
    if (leg.betType === "Call" && book && line) {
      const callWord = isDTS() ? "target" : "call";
      return [leg.teamName, `book ${book}`, `${callWord} ${line}`].filter(Boolean).join(" ");
    }
    const spread =
      book && line && book !== line ? `${book} → ${line}` : line || book;
    return [leg.teamName, spread].filter(Boolean).join(" ");
  }
  if (market === "h2h") {
    return [leg.teamName, getFeaturedMarketLabel("h2h", isDTS()), formatOdds(leg.price)]
      .filter(Boolean)
      .join(" ");
  }
  return leg?.teamName || "";
};

const resultStatus = (row) => historyResultStatus(row);

const resultAmount = (row) => {
  const stake = Number(row?.wagerAmount || 0);
  const payout = Number(row?.payOut || 0);
  if (historyResultIsNeutralAmount(row)) {
    return entryAmount(0, row.fundingCoinBucket);
  }
  if (row?.winStatus === "WIN") return entryAmount(payout - stake, row.fundingCoinBucket);
  if (row?.winStatus === "LOSS") return entryAmount(-stake, row.fundingCoinBucket);
  if (row?.winStatus === "PUSH") return entryAmount(0, row.fundingCoinBucket);
  return "Pending";
};

const optionsOne = [
  { value: "today", label: "Today" },
  { value: "thisWeek", label: "This Week" },
  { value: "thisMonth", label: "This Month" },
];

const placedDataDetails = [
  {
    id: 1,
    userOrPhone: "WIN/LOSS",
    datePlaced: "",
    sport: "Football",
    description: "blackjack",
    riskOrWin: "",
    winOrLoss: "",
    result: "-15",
    datePlacedTwo: "11/30/202306:58 AM",
  },
  {
    id: 2,
    userOrPhone: "WIN/LOSS",
    datePlaced: "",
    sport: "Football",
    description: "blackjack",
    riskOrWin: "",
    winOrLoss: "",
    result: "33",
    datePlacedTwo: "11/30/202306:59 AM",
  },
  {
    id: 3,
    userOrPhone: "WIN/LOSS",
    datePlaced: "",
    sport: "XFER",
    description: "TRANSFER TO AGENT: MICHAEL31",
    riskOrWin: "",
    winOrLoss: "",
    result: "-18",
    datePlacedTwo: "11/30/202306:58 AM",
  },
];

const HistoryContent = () => {
  const accountData = useSelector((state) => state.account);

  const [walletData, setwalletData] = useState([]);
  const [betHistory, setbetHistory] = useState([]);
  const [period, setPeriod] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [pageError, setPageError] = useState(null);
  const [historyRefreshing, setHistoryRefreshing] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!accountData?.emailId) {
        setPageLoading(false);
        return;
      }
      setPageLoading(true);
      setPageError(null);
      try {
        const wr = await getWalletDetails({ email: accountData.emailId });
        if (cancelled) return;
        if (wr.status !== true) {
          setPageError(wr.message || "Could not load account figures.");
          return;
        }
        setwalletData(wr.result);
        const hr = await getbetHistoryData({
          email: accountData.emailId,
          period: "today",
        });
        if (cancelled) return;
        if (hr.status !== true) {
          setPageError(hr.message || loadEntryHistoryFailedMessage());
        } else {
          if (hr.result && Array.isArray(hr.result.totalData)) {
            hr.result.totalData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          }
          setbetHistory(hr.result);
        }
      } catch (e) {
        if (!cancelled) {
          setPageError("Unable to load account history. Please try again.");
        }
      } finally {
        if (!cancelled) setPageLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [accountData]);

  const fetchbetHistoryData = async (periodArg) => {
    if (!accountData?.emailId) return;
    try {
      setHistoryRefreshing(true);
      setPageError(null);
      let { status, message, result } = await getbetHistoryData({
        email: accountData.emailId,
        period: periodArg ? periodArg : "today",
      });
      if (status == true) {
        if (result && Array.isArray(result.totalData)) {
          result.totalData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        }
        setbetHistory(result);
      } else {
        setPageError(message || "Could not update history for this period.");
      }
    } catch (err) {
      setPageError("Unable to load history for the selected period.");
    } finally {
      setHistoryRefreshing(false);
    }
  };

  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => {
      return {
        ...styles,
        backgroundColor: isHovered
          ? "#004062"
          : isSelected
            ? "#004062"
            : isFocused
              ? "#004062"
              : "",
        cursor: "pointer",
        color: isHovered
          ? "#fff"
          : isSelected
            ? "#ffffff"
            : isFocused
              ? "#ffffff"
              : "",
        fontSize: "13px",
        zIndex: 1,
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0 10px",
      // width: "180px",
      backgroundColor: "#070707",
      color: "#ffffff",
      border: "1px solid var(--mg_blue) ",
      borderRadius: 5,
      fontSize: "16px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "var(--mg_blue) ",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "var(--mg_blue) ",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
      // border: "1px solid #5A5869",
      borderRadius: 5,
      background: "#070707",
    }),

    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "red",
      };
    },
  };
  return (
    <>
      <DataFetchStatus loading={pageLoading}>
        <div className="">
          <div className="fo_tle_bg py-2 px-2 text-center">
            <p className="mb-0 ">ACCOUNT FIGURES</p>
          </div>

          {/* table */}

          <div>
            {isDTS() && betHistory?.figures ? (
                <Table responsive className="custom_table">
                  <thead>
                    <tr>
                      <th />
                      <th>CURRENT BALANCE</th>
                      <th>AVAILABLE BALANCE</th>
                      <th>AMOUNT AT RISK</th>
                      <th>LAST WEEK`S WIN/LOSS FIGURE</th>
                      <th>THIS WEEK`S WIN/LOSS FIGURE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{getGoldCoinName()}</td>
                      <td>{figureNumber(betHistory.figures.goldBalance)}</td>
                      <td>{figureNumber(betHistory.figures.goldBalance)}</td>
                      <td>{figureNumber(betHistory.figures.goldAtRisk)}</td>
                      <td>{figureNumber(betHistory.figures.lastWeek?.gold)}</td>
                      <td>{figureNumber(betHistory.figures.thisWeek?.gold)}</td>
                    </tr>
                    <tr>
                      <td>{getSweepsCoinName()}</td>
                      <td>{figureNumber(betHistory.figures.dreamBalance)}</td>
                      <td>{figureNumber(betHistory.figures.dreamBalance)}</td>
                      <td>{figureNumber(betHistory.figures.dreamAtRisk)}</td>
                      <td>{figureNumber(betHistory.figures.lastWeek?.dream)}</td>
                      <td>{figureNumber(betHistory.figures.thisWeek?.dream)}</td>
                    </tr>
                  </tbody>
                </Table>
            ) : (
            <Table responsive className="custom_table">
              <thead>
                <tr>
                  <th>CURRENT BALANCE($)</th>
                  <th>AVAILABLE BALANCE($)</th>
                  <th className="">AMOUNT AT RISK($)</th>
                  <th className="">LAST WEEK`S WIN/LOSS FIGURE($)</th>
                  <th className="">THIS WEEK`S WIN/LOSS FIGURE($)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {walletData?.walletData?.userBalance &&
                      walletData?.walletData?.userBalance?.toFixed(2)}
                  </td>
                  <td>
                    {walletData?.walletData?.userBalance &&
                      walletData?.walletData?.userBalance?.toFixed(2)}
                  </td>
                  <td>
                    {walletData?.walletData?.riskAmount &&
                      walletData?.walletData?.riskAmount?.toFixed(2)}
                  </td>
                  <td>
                    {walletData?.lastWeekFigure &&
                      walletData?.lastWeekFigure?.toFixed(2)}
                  </td>
                  <td>
                    {walletData?.thisWeekFigure &&
                      walletData?.thisWeekFigure?.toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </Table>
            )}
          </div>
        </div>

        <div className="mt-5">
          <Select
            styles={stylesgraybg}
            // menuIsOpen={true}
            options={optionsOne}
            className="react_slt select_dropdown_modal"
            placeholder="Today"
            isDisabled={historyRefreshing}
            onChange={(selectedOption) => {
              setPeriod(selectedOption.value);
              fetchbetHistoryData(selectedOption.value);
            }}
          />{" "}
          {historyRefreshing ? (
            <p className="small text-muted mt-2 mb-0">Updating history…</p>
          ) : null}
        </div>

        <div className="mt-5">
          <div className="fo_tle_bg py-2 px-2 text-center">
            <p className="mb-0 ">
              HISTORY | FROM {formatPlacedAt(betHistory?.startDate)} TO{" "}
              {formatPlacedAt(betHistory?.endDate)}
            </p>
          </div>

          {/* table */}

          <div>
            <Table responsive className="custom_table history_table">
              <thead>
                <tr>
                  <th></th>
                  <th className="text-center">SUN</th>
                  <th>MON</th>
                  <th className="">TUE</th>
                  <th className="">WED</th>
                  <th className="">THU</th>
                  <th className="">FRI</th>
                  <th className="">SAT</th>
                  {/* <th className="">TOTAL</th> */}
                </tr>
              </thead>
              <tbody>
                {isDTS() && betHistory?.figures?.daily ? (
                  <>
                    <tr>
                      <td>{getGoldCoinName()}</td>
                      {betHistory.figures.daily.map((day) => (
                        <td key={`gold-${day.day}`} className={day.day === 0 ? "text-center" : undefined}>
                          {figureNumber(day.gold)}
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <td>{getSweepsCoinName()}</td>
                      {betHistory.figures.daily.map((day) => (
                        <td key={`dream-${day.day}`} className={day.day === 0 ? "text-center" : undefined}>
                          {figureNumber(day.dream)}
                        </td>
                      ))}
                    </tr>
                  </>
                ) : (
                <tr>
                  <td>WIN/LOSS ($)</td>
                  <td className="text-center">
                    {betHistory &&
                      isEmpty(betHistory?.weekDaysData?.find((val) => val.day == 0))
                      ? 0
                      : betHistory?.weekDaysData?.find((val) => val.day == 0)
                        ?.winorloss}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.weekDaysData?.find((val) => val.day == 1))
                      ? 0
                      : betHistory?.weekDaysData?.find((val) => val.day == 1)
                        ?.winorloss}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.weekDaysData?.find((val) => val.day == 2))
                      ? 0
                      : betHistory?.weekDaysData?.find((val) => val.day == 2)
                        ?.winorloss}{" "}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.weekDaysData?.find((val) => val.day == 3))
                      ? 0
                      : betHistory?.weekDaysData?.find((val) => val.day == 3)
                        ?.winorloss}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.weekDaysData?.find((val) => val.day == 4))
                      ? 0
                      : betHistory?.weekDaysData?.find((val) => val.day == 4)
                        ?.winorloss}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.weekDaysData?.find((val) => val.day == 5))
                      ? 0
                      : betHistory?.weekDaysData?.find((val) => val.day == 5)
                        ?.winorloss}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.weekDaysData?.find((val) => val.day == 6))
                      ? 0
                      : betHistory?.weekDaysData?.find((val) => val.day == 6)
                        ?.winorloss}
                  </td>
                </tr>
                )}
                <tr>
                  <td>CASH IN ($)</td>
                  <td className="text-center">
                    {betHistory &&
                      isEmpty(betHistory?.cashIn?.find((val) => val.day == 0))
                      ? 0
                      : betHistory?.cashIn?.find((val) => val.day == 0)?.inAmount}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.cashIn?.find((val) => val.day == 1))
                      ? 0
                      : betHistory?.cashIn?.find((val) => val.day == 1)?.inAmount}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.cashIn?.find((val) => val.day == 2))
                      ? 0
                      : betHistory?.cashIn?.find((val) => val.day == 2)?.inAmount}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.cashIn?.find((val) => val.day == 3))
                      ? 0
                      : betHistory?.cashIn?.find((val) => val.day == 3)?.inAmount}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.cashIn?.find((val) => val.day == 4))
                      ? 0
                      : betHistory?.cashIn?.find((val) => val.day == 4)?.inAmount}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.cashIn?.find((val) => val.day == 5))
                      ? 0
                      : betHistory?.cashIn?.find((val) => val.day == 5)?.inAmount}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.cashIn?.find((val) => val.day == 6))
                      ? 0
                      : betHistory?.cashIn?.find((val) => val.day == 6)?.inAmount}
                  </td>
                  {/* <td>0</td> */}
                </tr>
                <tr>
                  <td>
                    {isDTS()
                      ? getTerm("redemption", { case: "upper" })
                      : "CASH OUT ($)"}
                  </td>
                  <td className="text-center">
                    {betHistory &&
                      isEmpty(betHistory?.cashOut?.find((val) => val.day == 0))
                      ? 0
                      : betHistory?.cashOut?.find((val) => val.day == 0)
                        ?.outAmount}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.cashOut?.find((val) => val.day == 1))
                      ? 0
                      : betHistory?.cashOut?.find((val) => val.day == 1)
                        ?.outAmount}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.cashOut?.find((val) => val.day == 2))
                      ? 0
                      : betHistory?.cashOut?.find((val) => val.day == 2)
                        ?.outAmount}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.cashOut?.find((val) => val.day == 3))
                      ? 0
                      : betHistory?.cashOut?.find((val) => val.day == 3)
                        ?.outAmount}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.cashOut?.find((val) => val.day == 4))
                      ? 0
                      : betHistory?.cashOut?.find((val) => val.day == 4)
                        ?.outAmount}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.cashOut?.find((val) => val.day == 5))
                      ? 0
                      : betHistory?.cashOut?.find((val) => val.day == 5)
                        ?.outAmount}
                  </td>
                  <td>
                    {betHistory &&
                      isEmpty(betHistory?.cashOut?.find((val) => val.day == 6))
                      ? 0
                      : betHistory?.cashOut?.find((val) => val.day == 6)
                        ?.outAmount}
                  </td>
                  {/* <td>0</td> */}
                </tr>
              </tbody>
            </Table>
          </div>
        </div>

        <div className="mt-5">
          <div>
            <Table responsive className="custom_table historyDls_table">
              <thead>
                <tr>
                  <th>SPORT</th>
                  <th>ENTRY</th>
                  <th>RESULT</th>
                  <th>{isDTS() ? "RISK / WIN" : "RISK / WIN ($)"}</th>
                  <th>{isDTS() ? "AMOUNT" : "AMOUNT ($)"}</th>
                  <th>PLACED</th>
                </tr>
              </thead>
              <tbody>
                {betHistory && betHistory?.totalData?.length > 0 ? (
                  betHistory?.totalData?.map((value, index) => {
                    const isWithdrawal =
                      value?.oddType === "WITHDRAWAL" || value?.isWithdrawal;
                    const wAmt = Number(value?.wagerAmount || 0);
                    const isAccepted = value?.winStatus === "Accepted";
                    const legs = Array.isArray(value?.legs) ? value.legs : [];
                    const rowKey = value?.ticketId || value?.reqId || `bet-${index}`;

                    return (
                    <tr key={rowKey}>
                      <td>{value?.title}</td>
                      <td>
                        <div className="history-entry">
                          {value?.ticketId ? (
                            <span className="history-entry__id">#{value.ticketId}</span>
                          ) : null}
                          <span className="history-entry__type">
                            {isWithdrawal
                              ? "Withdrawal"
                              : value?.betType
                                ? getEntryTypeLabel(value.betType, isDTS())
                                : value?.oddType}
                          </span>
                          {isWithdrawal ? (
                            <span>{value?.teamName}</span>
                          ) : legs.length > 0 ? (
                            <ul className="history-entry__legs">
                              {legs.map((leg, legIndex) => (
                                <li key={`${rowKey}-${legIndex}`}>
                                  {leg.homeTeam && leg.awayTeam
                                    ? `${leg.homeTeam} vs ${leg.awayTeam}`
                                    : leg.title}
                                  {" · "}
                                  {selectionLine(leg)}
                                  {leg.gameTime
                                    ? ` · ${formatEventKickoff(leg.gameTime, { includeTz: true })}`
                                    : ""}
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <span>
                              {value?.homeTeam && value?.awayTeam
                                ? `${value.homeTeam} vs ${value.awayTeam} · `
                                : ""}
                              {selectionLine(value)}
                            </span>
                          )}
                        </div>
                      </td>
                      <td>{isWithdrawal ? value?.winStatus || "Pending" : resultStatus(value)}</td>
                      <td>
                        {isWithdrawal
                          ? entryAmount(wAmt, value?.fundingCoinBucket)
                          : `${entryAmount(value?.wagerAmount, value?.fundingCoinBucket)} / ${entryAmount(
                              Number(value?.payOut || 0) - Number(value?.wagerAmount || 0),
                              value?.fundingCoinBucket
                            )}`}
                      </td>
                      <td>
                        {isWithdrawal
                          ? isAccepted
                            ? entryAmount(-wAmt, value?.fundingCoinBucket)
                            : entryAmount(0, value?.fundingCoinBucket)
                          : resultAmount(value)}
                      </td>
                      <td>{formatPlacedAt(value?.createdAt)}</td>
                    </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center p-3">
                      No History To Show
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </DataFetchStatus>
    </>
  );
};

export default HistoryContent;
